/**
 * A failed router→subgraph hop, as the Apollo Router reports it. The router
 * writes this message itself, so a subgraph's own errors cannot match. 5xx only:
 * a 4xx means the request was refused, which is a different fault.
 */
export function matchSubgraphFetchFailure(
  message: string | undefined,
): { subgraph: string; status: string } | undefined {
  const match = /HTTP fetch failed from '([^']+)': (5\d\d)/.exec(message ?? "");
  return match === null ? undefined : { subgraph: match[1], status: match[2] };
}
